const BASELINE_GRID = 4
const ROOT_FONT_SIZE = 16

export const unitless = (value: number): number => BASELINE_GRID * value

export const unit = (value: number): string => `${unitless(value)}px`

export const remUnit = (value: number): string => `${unitless(value) / ROOT_FONT_SIZE}rem`
